<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-btn flat slot="activator">
      <v-icon>edit</v-icon>
    </v-btn>
    <v-card>
      <v-card-title>
        <span class="headline">{{$t('title-edit-gateway')}}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>                                                                                                                                     
            <v-flex xs12 sm6 md4>
              <v-text-field
                v-model="gateway.title"
                :rules="onlyRequiredRule"
                :label="$t('name-housing-unit')"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <transition name="fade">
        <v-card-text v-if="error" class="error-msg">
          <p>{{error}}</p>
        </v-card-text>
      </transition>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="dialog = false">{{$t('close')}}</v-btn>
        <v-btn color="blue darken-1" flat @click.native="save">{{$t('save')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import router from '@/router';
export default {
  name: 'gateway-edit',
  props: ['gateway'],
  data: () => {
    return {
      onlyRequiredRule: [v => !!v || 'Item is required.'],
      dialog: false,
      error: null
    };
  },
  computed: {
    user: function() {
      return this.$store.getters.user;
    }
  },
  methods: {
    save: function() {
      this.$store
        .dispatch('flats/put', {
          flat: this.gateway.flat,
          title: this.gateway.title
        })
        .then(() => {
          this.dialog = false;
          router.push('/');
        })
        .catch(e => {
          //segnalare l'errore
          console.log(e.response);
          this.error = e.response.data.message || e;
        });
    }
  }
};
</script>

<style>
</style>
